<div class="saving-indicator" [ngClass]="{
    'si--off': !saveState,
    'si--on': saveState
}">Saving 
<i app-svg-icon name="refresh" classList="icon  icon-16" class="si__icon"></i>
</div>